import moment from 'moment-timezone';
import { IAttachment, IAttachmentData } from '../attachment';
import { AbstractModel } from '../base';
import {
  IMentionComment,
  IMentionCommentData,
  MentionCommentMixin
} from '../mention';
import {
  IAttachmentComment,
  IComment,
  ICommentData,
  IMentionAttachmentComment,
  IMentionAttachmentCommentData
} from './comment.types';

export abstract class AbstractComment extends AbstractModel
  implements IComment {
  readonly id?: number;
  readonly owner?: string;
  readonly text: string;
  readonly created_at?: Date | string;
  readonly updated_at?: Date | string;

  protected constructor(data: ICommentData) {
    super();

    const requiredFields: (keyof ICommentData)[] = ['text'];
    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    if (data.owner) {
      this.owner = data.owner;
    }

    this.text = data.text!;

    if (data.created_at) {
      this.created_at = data.created_at;
    }

    if (data.updated_at) {
      this.updated_at = data.updated_at;
    }
  }

  abstract toString(): string;

  get isCommentEdited(): boolean {
    //milliseconds is different for both fields
    return (
      moment(this.created_at).format('YYYY-MM-DDTHH:mm:ss') !==
      moment(this.updated_at).format('YYYY-MM-DDTHH:mm:ss')
    );
  }
}

export abstract class AbstractAttachmentComment extends AbstractComment
  implements IAttachmentComment {
  abstract readonly attachments: IAttachment[];

  protected constructor(data: IAttachmentData) {
    super(data);

    this.validate(data, []);
  }

  abstract toString(): string;
}

export abstract class AbstractMentionComment extends MentionCommentMixin
  implements IMentionComment, IComment {
  readonly id?: number;
  readonly owner?: string;
  text = '';
  readonly created_at?: Date | string;
  readonly updated_at?: Date | string;

  protected constructor(data?: IMentionCommentData & ICommentData) {
    super(data);
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.owner) {
        this.owner = data.owner;
      }

      this.text = data.text!;

      if (data.created_at) {
        this.created_at = data.created_at;
      }

      if (data.updated_at) {
        this.updated_at = data.updated_at;
      }
    }
  }

  get isCommentEdited(): boolean {
    //milliseconds is different for both fields
    return (
      moment(this.created_at).format('YYYY-MM-DDTHH:mm:ss') !==
      moment(this.updated_at).format('YYYY-MM-DDTHH:mm:ss')
    );
  }

  abstract toString(): string;
}

export abstract class AbstractMentionAttachmentComment
  extends AbstractMentionComment
  implements IMentionAttachmentComment {
  abstract readonly attachments: IAttachment[];

  protected constructor(data?: IMentionAttachmentCommentData) {
    super(data);
  }

  abstract toString(): string;
}
